export default object => ({
  id: object.id,
  status: object.status,
  type: object.type,
  number: object.number,
  year: object.year,
});
